<template>
    <div>
        <v-toolbar color="primary" dark dense>
            <v-icon v-if="icon" class="mr-2">{{icon}}</v-icon>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="showSave" icon @click="save()">
                <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn v-else-if="showBack" icon @click="back()">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
        </v-toolbar>
        <fab-btn-back v-if="showBack && !hideBackFab" style="z-index: 5" @back="back">
        </fab-btn-back>
    </div>
</template>

<script>
import FabBtnBack from "./fabBtnBack";
export default {
    components: {FabBtnBack},
    name: "toolbar",
    props: ['backWithFab', 'icon', 'title', 'showSave', 'showBack', 'hideBackFab'],
    methods: {
        async back(){
            window.history.back();
        },
        save(){
            this.$emit('save');
        },
    },
}
</script>

<style scoped>

</style>